import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-quick-menu-item',
  templateUrl: './quick-menu-item.component.html',
  styleUrls: ['./quick-menu-item.component.scss'],
})

/**
 * Quick menu item
 */
export class QuickMenuItemComponent {
  @Input() icon?: string;
  @Output() clickAction = new EventEmitter<any>();
  _isActive = false;

  /**
   * Emits click action event for underlying material button
   */
  emitClick() {
    this.clickAction.emit();
  }

  /**
   * Decides if this item is active
   * @return {boolean}
   */
  @Input()
  get active(): boolean {
    return this._isActive;
  }

  /**
   * Sets this item as a active one by using an html attribute
   * @param {any} value
   */
  set active(value: any) {
    this._isActive = coerceBooleanProperty(value);
  }
}
